import gql from 'graphql-tag';
import { PriceTierFragment } from '@/graphql/fragments';

export default gql`
  query nodeQuery($id: ID!) {
    node(id: $id) {
      __typename
      ...PriceTierFragment
    }
  }
  ${PriceTierFragment}
`;
